import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { LocationService } from '@core/jss-seo';
import { FehApiActions } from '@feh/shared-api';

import {
  resetSubmitState,
  submitHomebatteryAdviceForm,
} from './homebattery-advice-form.actions';
import { homebatteryAdviceFormSelectorKey } from './homebattery-advice-form.reducer';
import { selectHomebatteryAdviceRedirectUrl } from './homebattery-advice-form.selectors';

@Injectable()
export class HomebatteryAdviceFormEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly location = inject(LocationService);

  submitForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(submitHomebatteryAdviceForm),
      map(({ payload }) =>
        FehApiActions.postHomebatteryV1.requestAction({
          actionId: homebatteryAdviceFormSelectorKey,
          payload,
        })
      )
    );
  });

  handleCreateLeadSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FehApiActions.postHomebatteryV1.successAction),
      filter((params) => params.actionId === homebatteryAdviceFormSelectorKey),
      concatLatestFrom(() => [
        this.store.select(selectHomebatteryAdviceRedirectUrl),
      ]),
      tap(([_, redirectUrl]) => {
        this.location.navigateGeneralLink(redirectUrl?.value?.href as string);
      }),
      map(resetSubmitState)
    )
  );
}
